<template>
  <div>
    <v-navigation-drawer
      :mobile-breakpoint="display"
      app
      v-model="drawer"
      @input="detectAction"
      width="320"
    >
      <v-tabs
        v-model="tab"
        background-color="primary"
        vertical
        dark
        class="line-sidebar"
      >
        <div class="logo accent">
          <img
            src="@/assets/logo-nav.png"
            style="width: 50%"
            class="ma-auto"
            alt="logo"
          />
        </div>
        <div>
          <v-tab v-if="user.level != 'USER'" href="#meters" class="mx-auto">
            <v-icon>mdi-lightning-bolt-circle</v-icon>
          </v-tab>
          <v-tab href="#maps"> <v-icon>mdi-map-marker</v-icon> </v-tab>
          <v-tab v-if="user.level != 'USER'" href="#groups">
            <v-icon>mdi-google-circles-communities</v-icon>
          </v-tab>
        </div>
      </v-tabs>

      <v-tabs-items v-model="tab" class="div-1">
        <v-tab-item :value="'meters'" class="h-100">
          <v-card flat class="h-100">
            <div>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="title"> Devices </v-list-item-title>
                  <v-list-item-subtitle>
                    Registered Devices
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-btn icon @click="detectAction(false)">
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                </v-list-item-icon>
              </v-list-item>
              <v-divider block></v-divider>
              <v-row class="mx-1 d-flex d-md-none">
                <v-col cols="4">
                  <v-btn
                    v-if="tab == 'meters'"
                    class="ma-0"
                    block
                    color="accent"
                    @click="mainMap"
                  >
                    <v-icon>mdi-map-marker</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="4">
                  <v-btn
                    v-if="tab == 'meters'"
                    color="accent"
                    class="ma-0"
                    block
                    @click="actionNew"
                  >
                    <v-icon>mdi-plus-circle</v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="4">
                  <download-csv :data="json_data" :name="date">
                    <v-btn
                      v-if="tab == 'meters'"
                      color="accent"
                      class="ma-0"
                      block
                      @click="downloadReport"
                    >
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                  </download-csv>
                </v-col>
              </v-row>
              <v-text-field
                v-model="filter_meter.filter"
                solo
                outlined
                dense
                flat
                append-icon="mdi-magnify"
                class="ml-4 mt-md-3 mb-n2 mr-6"
                @input="filterMeters()"
                label="Search a device..."
              ></v-text-field>
            </div>
            <v-card-text class="pa-0 list-body">
              <v-list v-if="meters.length > 0" nav flat dense three-line>
                <v-list-item-group dense>
                  <v-divider></v-divider>
                  <div v-for="(meter, index) in filter_meter.data" :key="index">
                    <v-list-item color="primary">
                      <v-list-item-icon class="mr-2 my-auto">
                        <v-icon small> mdi-lightning-bolt-circle </v-icon>
                      </v-list-item-icon>

                      <v-list-item-content
                        @click="changeView('meters', meter.name)"
                      >
                        <v-list-item-title class="mb-n5">{{
                          meter.circuit
                        }}</v-list-item-title>
                        <v-list-item-subtitle class="mt-0">{{
                          meter.gateway.id
                        }}</v-list-item-subtitle>
                      </v-list-item-content>

                      <v-list-item-action class="mr-2 my-3">
                        <v-btn icon @click="editMeter(meter.name)">
                          <v-icon small> mdi-pencil </v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                    <v-divider :key="index" class="ma-0"></v-divider>
                  </div>
                </v-list-item-group>

                <v-list-item v-if="noMeters">
                  <v-list-item-content>
                    <v-list-item-subtitle
                      class="mt-3 text-wrap text-center font-weight-bold"
                      >No items found</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-list v-else>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-icon style="position: relative; left: 105px">
                      <v-icon x-large>mdi-plus-circle</v-icon>
                    </v-list-item-icon>
                    <v-list-item-subtitle
                      class="mt-3 text-wrap text-center font-weight-bold"
                      >Click on "Add device" button to add new
                      devices</v-list-item-subtitle
                    >
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="'schedules'">
          <v-card flat>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="title"> Horarios </v-list-item-title>
                <v-list-item-subtitle> Lista de horarios </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-btn icon @click="detectAction(false)">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </v-list-item-icon>
            </v-list-item>
            <v-divider></v-divider>
            <v-row class="mx-1 d-flex d-md-none">
              <v-col cols="12">
                <v-btn color="accent" class="ma-0" block @click="actionNew">
                  <v-spacer>Añadir nuevo</v-spacer>
                  <v-icon>mdi-plus-circle</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-list nav dense>
              <v-list-item
                v-for="schedule in schedules"
                :key="schedule.name"
                color="primary"
                :to="{ name: 'Schedule', params: { id: schedule.id } }"
                link
              >
                <v-list-item-icon>
                  <v-icon>mdi-clock-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>{{ schedule.name }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-icon>
                  <v-icon color="accent" @click="editSchedule(schedule.id)"
                    >mdi-pencil</v-icon
                  >
                </v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="'maps'">
          <v-card flat>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="title"> Maps </v-list-item-title>
                <v-list-item-subtitle> Select a map </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-btn icon @click="detectAction(false)">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </v-list-item-icon>
            </v-list-item>
            <v-divider></v-divider>
            <div>
              <v-card
                :height="height"
                flat
                max-width="350"
                class="mx-auto my-auto overflow-y-auto"
              >
                <v-virtual-scroll item-height="50" bench="0" :items="maps">
                  <template v-slot:default="{ item }">
                    <v-list-item
                      :key="item.id"
                      link
                      dense
                      @click="moveToMap({ id: item.id, btn: item.btn })"
                    >
                      <v-list-item-icon class="my-auto">
                        <v-icon> mdi-map-marker </v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-card-text
                          class="font-weight-bold text-caption mx-n4"
                        >
                          {{ item.id }} MAP
                        </v-card-text>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-virtual-scroll>
              </v-card>
            </div>
          </v-card>
        </v-tab-item>
        <v-tab-item :value="'groups'" class="h-100">
          <v-card flat class="h-100">
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="title"> Groups </v-list-item-title>
                <v-list-item-subtitle> Select a group </v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon>
                <v-btn icon @click="detectAction(false)">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
              </v-list-item-icon>
            </v-list-item>
            <v-divider></v-divider>
            <v-row class="mx-1 d-flex d-md-none">
              <v-col>
                <v-btn class="ma-0" block color="accent" @click="actionNew">
                  <v-spacer>Create group</v-spacer>
                  <v-icon>mdi-plus-circle</v-icon>
                </v-btn>
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <div>
              <v-card-text class="pa-0 list-body">
                <v-list class="h-100">
                  <v-list-group
                    v-for="group in groupMeters"
                    :key="group.name"
                    v-model="group.status"
                    prepend-icon="mdi-lightbulb-on"
                    no-action
                  >
                    <template v-slot:activator>
                      <v-list-item-content>
                        <v-list-item-title
                          class="font-weight-bold text-caption"
                          v-text="group.name"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </template>

                    <v-list-item
                      v-for="meter in group.meters"
                      :key="meter.name"
                      @click="changeView('meters', meter.name)"
                      link
                    >
                      <v-list-item-content>
                        <v-list-item-title
                          class="font-weight-bold text-caption mb-1"
                          v-text="meter.circuit"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          class="mt-0 text-caption font-weight-medium"
                          v-text="meter.gateway.id"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                    <div class="spacing">
                      <v-list-item-content>
                        <v-list-item-subtitle
                          class="font-weight-bold text-caption grey--text text--darken-1 my-n5 mx-auto"
                        >
                          <v-list-item-action>
                            <v-btn
                              small
                              color="accent"
                              text
                              @click="changeView('groups', group)"
                            >
                              <v-spacer>GO TO DASHBOARD</v-spacer>
                              <v-icon class="ml-2" small
                                >mdi-view-dashboard</v-icon
                              >
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-content @click="showGroupMap(group)">
                        <v-list-item-subtitle
                          class="font-weight-bold text-caption grey--text text--darken-1 my-n5 mx-auto"
                        >
                          <v-list-item-action>
                            <v-btn small color="accent" text>
                              <v-spacer>SHOW DEVICES ON MAP</v-spacer>
                              <v-icon class="ml-2" small>mdi-map-marker</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                      <v-list-item-content>
                        <v-list-item-subtitle
                          class="font-weight-bold text-caption grey--text text--darken-1 my-n5 mx-auto"
                        >
                          <v-list-item-action>
                            <v-btn
                              small
                              color="accent"
                              text
                              @click="editGroup(group.name)"
                            >
                              <v-spacer>EDIT GROUP</v-spacer>
                              <v-icon class="ml-2" small>mdi-pencil</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </div>
                  </v-list-group>
                </v-list>
              </v-card-text>
            </div>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
      <div class="buttons-action">
        <v-card
          flat
          class="d-none d-lg-block d-md-block d-xl-block text-center mx-n7 mr-n3 pa-3 mb-n2 rounded-0"
          max-width="350"
        >
          <v-btn
            v-if="tab == 'meters'"
            class="mb-3"
            block
            color="accent"
            @click="mainMap"
          >
            <v-spacer>Map</v-spacer> <v-icon>mdi-map-marker</v-icon>
          </v-btn>
          <v-btn
            v-if="tab == 'meters'"
            color="accent"
            class="mb-5 mb-md-3"
            block
            @click="actionNew"
          >
            <v-spacer>Add device</v-spacer> <v-icon>mdi-plus-circle</v-icon>
          </v-btn>
          <download-csv :data="json_data" :name="date" v-if="tab == 'meters'">
            <v-btn
              color="accent"
              class="mb-5 mb-md-0"
              block
              @click="downloadReport"
            >
              <v-spacer>Download Report</v-spacer>
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </download-csv>
          <v-btn
            v-if="tab == 'groups'"
            color="accent"
            class="mb-5 mb-md-3"
            block
            @click="actionNew"
          >
            <v-spacer>Create new group</v-spacer>
            <v-icon>mdi-plus-circle</v-icon>
          </v-btn>
        </v-card>
      </div>
    </v-navigation-drawer>
    <formMeter
      :open="meter_form.open"
      @close="actionCloseNew"
      :meter_id="meter_form.meter"
    />
    <formSchedule
      :open="form_schedule.open"
      @close="actionCloseNew"
      :schedule_id="form_schedule.schedule"
    />
    <formGroups
      :open="group_menu.open"
      @close="actionCloseNew"
      :group_id="group_menu.group"
      :group_meters="group_menu.meters"
      :prev="group_menu.group"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import formMeter from "../formGateway";
import formSchedule from "../formSchedule";
import formGroups from "../formGroups";

import Vue from "vue";
import JsonCSV from "vue-json-csv";
Vue.component("downloadCsv", JsonCSV);

export default {
  name: "sidebar",
  props: ["drawer"],
  computed: {
    ...mapState({
      user: (state) => state.user.profile,
      meters: (state) => state.meters.meters,
      schedules: (state) => state.schedules.schedules,
      view: (state) => state.user.view,
      groupMeters: (state) => state.meters.groupMeters,
    }),
  },
  components: { formMeter, formSchedule, formGroups },
  data() {
    return {
      tab: null,
      meter_form: { open: false, meter: null },
      form_schedule: { open: false, schedule: null },
      group_menu: { open: false, group: null, meters: [] },
      filter_meter: { data: [], filter: "" },
      json_data: [],
      date: "",
      activate: false,
      height: 550,
      display: "",
      maps: [
        { id: "GENERAL", btn: 4 },
        { id: "CONSUMPTION", btn: 6 },
        { id: "SIGNAL", btn: 10 },
      ],
      metersList: [],
      pressed: false,
      noMeters: false,
    };
  },
  methods: {
    detectAction(value) {
      value = !undefined
        ? this.$emit("close-drawer", value)
        : this.$emit("close-drawer", this.drawer);
    },
    actionNew() {
      switch (this.tab) {
        case "meters":
          this.meter_form.open = true;
          break;
        case "schedules":
          this.form_schedule.open = true;
          break;
        case "groups":
          this.group_menu.open = true;
          this.group_menu.group = "";
          this.group_menu.meters = [];
          break;
        default:
          break;
      }
    },
    async actionCloseNew() {
      switch (this.tab) {
        case "meters":
          this.meter_form.meter = null;
          this.meter_form.open = false;
          this.filter_meter.filter = "";
          break;
        case "schedules":
          this.form_schedule.schedule = null;
          this.form_schedule.open = false;
          break;
        case "groups":
          this.group_menu.group = null;
          this.group_menu.open = false;
          this.group_menu.meters = [];
          break;
        default:
          break;
      }
      await this.updateList();
    },
    editSchedule(schedule) {
      this.form_schedule.schedule = schedule;
      this.form_schedule.open = true;
    },
    editMeter(meter) {
      this.meter_form.meter = meter;
      this.meter_form.open = true;
    },
    editGroup(group) {
      this.group_menu.open = true;
      this.group_menu.group = group;
      let n = this.groupMeters.findIndex((n) => n.name === group);
      this.group_menu.meters = this.groupMeters[n];
    },
    filterMeters() {
      if (this.filter_meter.filter !== "") {
        this.filter_meter.data = this.meters.filter(
          (m) =>
            m.circuit
              .toLowerCase()
              .indexOf(this.filter_meter.filter.toLowerCase()) > -1 ||
            m.gateway.id
              .toLowerCase()
              .indexOf(this.filter_meter.filter.toLowerCase()) > -1
        );
        if (this.filter_meter.data.length === 0) {
          this.noMeters = true;
        } else {
          this.noMeters = false;
        }
      } else {
        this.filter_meter.data = [];
        this.noMeters = false;
      }
    },
    downloadReport() {
      let today = new Date();
      this.date = `reporte_${today.toLocaleString()}.csv`;
      for (let index = 0; index < this.meters.length; index++) {
        let m = {
          nombre: this.meters[index].name,
          active: this.meters[index].active,
          control: this.meters[index].control,
          status: this.meters[index].active
            ? this.meters[index].control
              ? "Encendido"
              : "Apagado"
            : "Fuera de línea",
          fotocelda: this.meters[index].fotocelda,
          latitud: this.meters[index].location.latitude,
          longitud: this.meters[index].location.longitude,
        };
        this.json_data.push(m);
      }
    },
    activeEditButton() {
      this.activate = true;
    },
    deactiveEditButton() {
      this.activate = false;
    },
    mainMap() {
      this.$router
        .push({
          name: "Map",
          params: {
            location: this.user.location,
            id: "general",
            zoom: this.user.map_zoom,
            btn: 4,
            signal: false,
          },
        })
        .catch(() => {});
    },
    moveToMap(map) {
      this.$router
        .push({
          name: "Map",
          params: {
            location: this.user.location,
            id: map.id.toLowerCase(),
            zoom: this.user.map_zoom,
            btn: map.btn,
            signal: false,
          },
        })
        .catch(() => {});
    },
    heightMetersList() {
      return;
    },
    height_calc() {
      switch (this.$vuetify.breakpoint.name) {
        case "xl":
          this.height = 650;
          break;
        default:
          this.height = 350;
          break;
      }
    },
    drawerState() {
      return;
    },
    async setMeters() {
      if (this.filter_meter.data.length === 0)
        this.filter_meter.data = this.meters;
    },
    async updateList() {
      this.filter_meter.data = await this.meters;
    },
    changeView(menu, value) {
      switch (menu) {
        case "meters":
          this.$router
            .push({ name: "Circuit", params: { meter: value, id: value } })
            .catch(() => {}); //id: value.name,
          break;
        case "groups":
          let name = value.name.toLowerCase().replace(/\s+/g, "");
          this.$router
            .push({
              name: "GroupCircuit",
              params: { id: name, groupData: value, origName: value.name },
            })
            .catch(() => {});
          break;
        default:
          break;
      }
    },
    showGroupMap(group) {
      let name = group.name.toLowerCase().replace(/\s+/g, "");
      this.$router.push({
        name: "GroupMap",
        params: { id: name, name: group.name, meters: group.meters },
      });
    },
  },
  created() {
    this.setMeters();
    this.height_calc();
  },
  mounted() {
    this.filterMeters();
    this.$vuetify.breakpoint.md = 340;
    this.display = this.$vuetify.breakpoint.md;
    this.$root.$on("sidebar", () => {
      this.drawerState();
    });
    if (this.user.level === "USER") {
      this.maps = [{ id: "GENERAL", btn: 4 }];
    }
  },
};
</script>

<style scoped>
.v-tabs {
  position: absolute;
  height: 100%;
  width: 60px;
  left: 0;
  top: 0;
}
.v-tab {
  min-width: unset !important;
  left: -3px;
}
.v-tabs-items {
  margin-left: 50px; /*40*/
}
.logo {
  display: flex;
  height: 68px;
  width: 60px;
  margin-left: -5px;
}
.buttons-action {
  /*Botones*/
  position: absolute;
  bottom: 0px;
  right: 13px;
  width: 220px;
  left: 80px;
}
.margin-md {
  margin-bottom: 110px;
}
.row-pointer {
  cursor: pointer;
}
::v-deep .v-text-field .v-label {
  font-size: 12px;
}
.main {
  position: relative;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.main::-webkit-scrollbar {
  display: none;
}
.div-1 {
  /*Barra contenidos*/
  position: static;
  width: 275px;
  top: 0px;
  overflow: hidden;
  height: 100%;
}
.list-body {
  height: 65%;
  overflow-y: scroll;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.list-body::-webkit-scrollbar {
  display: none;
}
.h-100 {
  position: relative;
  height: 100%;
}
.line-sidebar {
  /*Barra indicadores*/
  width: 50px;
  text-align: center;
  position: fixed;
}
.spacing {
  position: relative;
  text-align: left;
  /* left: 73px */
  left: 60px;
  width: 250px;
}
</style>
